import api from "./api";

export const getTags = async () => {
    try {
        const response = await api.get(`/tags?populate=*`);
        // console.log(response.data.data);
        return (response.data.data);
    } catch (e) {
        console.error(e);
    }
};

export const getSingleTag = async (id) => {
    try {
        const response = await api.get(`/tags/${id}?populate=*`);
        // console.log(response.data.data);
        return (response.data.data);
    } catch (e) {
        console.error(e);
    }
};

export const countTags = async () => {
    try {
        const response = await getTags();
        const length = response.length;
        // console.log(response.data.data);
        return length;
    } catch (e) {
        console.error(e);
    }
};

export const getFilteredTags = async (filters = {}, page = 1, pageSize = 12) => {
    try {
        const queryParams = {
            populate: '*',
            filters: {},
            pagination: {
                page,
                pageSize
            }
        };

        // Add search term if provided
        if (filters.search) {
            queryParams.filters.$or = [
                {
                    name: {
                        $containsi: filters.search
                    }
                }
            ];
        }

        // Add sorting if provided
        if (filters.sort) {
            queryParams.sort = [filters.sort];
        }

        const response = await api.get('/tags', { params: queryParams });
        return {
            data: response.data.data,
            pagination: response.data.meta.pagination
        };
    } catch (e) {
        console.error(e);
        return {
            data: [],
            pagination: {
                page: 1,
                pageSize: pageSize,
                pageCount: 0,
                total: 0
            }
        };
    }
};

export const deleteTag = async (id) => {
    try {
        const response = await api.delete(`/tags/${id}`);
        // console.log(response);
        return true;
    } catch (err) {
        console.error('Error deleting tag:', err);
        return false
    }
};